import React, { Fragment, useEffect, useState } from 'react';
import { gAPI_QuestionSets } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { Row, Label, Button, Input, Card, CardBody } from 'reactstrap';
import { useSelector } from 'react-redux';

const DynamicFlow = ({
  lang,
  channelDetails,
  propertyList,
  integrationId,
  rows,
  setRows,
  propertyAssistant,
  setPropertyAssistant,
}) => {
  const propertyId = useSelector((state) => state?.settings?.propertyId);
  console.log('rows:', rows);
  useEffect(() => {
    if (!propertyList?.length) return;

    const savedFlows =
      channelDetails?.autonomousReplies?.dynamicConversationFlow;

    if (savedFlows?.length > 0) {
      // Ensure row count matches properties count
      const alignedRows = propertyList.map((p) => {
        const saved = savedFlows.find((sf) => sf.propertyId === p.id);
        return {
          propertyId: p.id,
          dynamicConversationFlowId: saved?.dynamicConversationFlowId || '',
        };
      });

      setRows(alignedRows);
    } else {
      // No saved data -> initialize empty rows
      const initial = propertyList.map((p) => ({
        propertyId: p.id,
        dynamicConversationFlowId: '',
      }));
      setRows(initial);
    }
  }, [propertyList, channelDetails]);

  // LOAD CONVERSATION FLOWS PER PROPERTY

  useEffect(() => {
    if (!propertyList?.length) return;

    let assistants = [];

    const loadFlows = async () => {
      const requests = propertyList.map(async (p) => {
        return AxiosAPI({
          methed: 'get',
          url: `${gAPI_QuestionSets}/?propertyId=${p.id}&groupId=${getGroupID()}&lang=${lang}`,
        }).then((res) => {
          const sets =
            res.data.sets?.sort((a, b) => a.displayOrder - b.displayOrder) ||
            [];

          const flows = sets
            .filter(
              (l) =>
                l.type === 'DynamicConversationFlow' &&
                l.openAiAssistantId !== ''
            )
            .map((l) => ({
              id: l.openAiAssistantId,
              name: l.name,
              isGroupLevel: l?.isGroupVisible ?? false,
              pid: p.id,
            }));

          assistants.push({
            pid: p.id,
            lst: flows,
          });
        });
      });

      await Promise.all(requests);
      setPropertyAssistant(assistants);
    };

    loadFlows();
  }, [propertyList]);

  //HANDLE DROPDOWN CHANGE
  const handleChange = (index, event) => {
    const { name, value } = event.target;

    const updated = [...rows];
    updated[index][name] = value;

    setRows(updated);
  };

  return (
    <Fragment>
      <Card className="p-3 ">
        <h6>Select Conversation Flows</h6>
        <Row className="w-100 my-2">
          <Colxx md={6}>
            <h6 style={{ fontSize: '14px' }}>Property</h6>
          </Colxx>
          <Colxx md={6} className="px-0">
            <h6 style={{ fontSize: '14px' }}>Conversation Flow</h6>
          </Colxx>
        </Row>
        {propertyList?.map((property, index) => {
          const propertyRecord = propertyAssistant
            ?.find((f) => f.pid === property.id)
            ?.lst?.find(
              (set) => set?.id == rows[index]?.dynamicConversationFlowId
            );
          const isNavigateToConversationFlow =
            propertyRecord?.isGroupLevel == true
              ? propertyId == '-1'
              : propertyId != '-1';
          return (
            <Row key={property.id} className="mb-2 w-100">
              <Colxx md={6} className="d-flex align-items-center">
                <div>{property.name}</div>
              </Colxx>
              <Colxx md={6} className="px-0">
                <Input
                  className="pr-4"
                  type="select"
                  name="dynamicConversationFlowId"
                  value={rows[index]?.dynamicConversationFlowId || ''}
                  onChange={(e) => handleChange(index, e)}
                >
                  <option value="">Select a Dynamic Conversation Flow</option>
                  {propertyAssistant
                    ?.find((f) => f.pid === property.id)
                    ?.lst?.map((assist, idx) => (
                      <option key={idx} value={assist.id}>
                        {assist.isGroupLevel
                          ? `${assist.name} (${assist.id}) (Group Level)`
                          : `${assist.name} (${assist.id})`}
                      </option>
                    ))}
                </Input>
              </Colxx>
              <Colxx md={6}>
                {rows[index]?.dynamicConversationFlowId &&
                  isNavigateToConversationFlow && (
                    <div className="mt-1">
                      <a
                        href={`/app/pages/propinfo/recommender?assistantId=${rows[index]?.dynamicConversationFlowId}`}
                        target="_self"
                        rel="noopener noreferrer"
                        style={{
                          color: 'red',
                          textDecoration: 'underline',
                          fontSize: '15px',
                        }}
                      >
                        Go to conversation flow
                      </a>
                    </div>
                  )}
              </Colxx>
            </Row>
          );
        })}
      </Card>
    </Fragment>
  );
};

export default DynamicFlow;
